import { render, staticRenderFns } from "./AddTransactionDialog.vue?vue&type=template&id=2a6e905b"
import script from "./AddTransactionDialog.vue?vue&type=script&lang=js"
export * from "./AddTransactionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports